// extracted by mini-css-extract-plugin
export var chevronIcon = "_e8-2";
export var teamName = "_e8-1";
export var teamSwitcherButton = "_e8-0";